import {Component, NgZone, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CommonModule, CurrencyPipe, ViewportScroller} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {SEOService} from '../../../../core/services/seo.service';
//import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import {Globals} from '../../../../core/services/globals';

import {FooterComponent} from '../../../../shared/components/footer/footer.component';
import {NavigationComponent} from '../../../../shared/components/navigation/navigation.component';
import {NavigationDetailsFullComponent} from '../../../../shared/components/navigation/navigation-details-full.component';
import {ContactFormComponent} from '../../../../shared/components/contact-form/contact-form.component';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Listing} from '../../../../core/models/listing';
import {MuskokaListingsService} from "../../services/muskoka-listings.service";
import {TrackingService} from "../../../../core/services/tracking.service";
import {NavbarBehaviorService} from "../../../../core/services/navbar-behavior.service";
import {BaseListingDetailsComponent} from "../../../../shared/components/base-listing-details/base-listing-details.component";
import {BsModalService} from "ngx-bootstrap/modal";


@Component({
  standalone: true,
  imports: [
    CommonModule,
    // ScrollToModule,
    FooterComponent,
    NavigationComponent,
    NavigationDetailsFullComponent,
    ContactFormComponent
  ],
  providers: [
    CurrencyPipe,  // <-- Add this if needed
    NavbarBehaviorService
  ],
  selector: 'muskoka-listing-details-full',
  templateUrl: './muskoka-listing-details-full.component.html',
  styleUrls: ['../../../../shared/components/listing-details/listing-details-full.component.css'],
  encapsulation: ViewEncapsulation.None // Important for global

})

export class MuskokaListingDetailsFullComponent extends BaseListingDetailsComponent implements OnInit, OnDestroy {

  constructor(
    protected override router: Router,
    protected override route: ActivatedRoute,
    protected override http: HttpClient,
    protected override listingsService: MuskokaListingsService,
    protected override SEOService: SEOService,
    public override globals: Globals,
    protected override _sanitizer: DomSanitizer,
    protected override scroller: ViewportScroller,
    protected override trackingService: TrackingService,
    protected override breakpointObserver: BreakpointObserver,
    protected override navbarService: NavbarBehaviorService,
    protected override modalService: BsModalService,
    protected override zone: NgZone
  ) {
    super(
      router,
      route,
      http,
      listingsService,
      SEOService,
      globals,
      _sanitizer,
      scroller,
      trackingService,
      breakpointObserver,
      navbarService,
      modalService,
      zone
    )
  }

  ngOnInit() {
    this.initializeBaseListingDetails();
  }

  ngOnDestroy(): void {
    this.cleanupBaseDashboard();
    // Complete the destroyed$ subject to prevent memory leaks
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  protected override onListingFetched(listings: Listing): void {
    //console.log('onListingFetched: ', listings);
  }
}
